import { DownOutlined, LogoutOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu, notification, Skeleton, Space } from 'antd';
import { FC } from 'react';
import { viewerModel } from 'entities/viewer';
import { useAppDispatch, useAppSelector } from 'app/store';
import { useLogoutMutation } from 'app/services/edpApiV1/auth';
import { useMeQuery } from 'app/services/edpApiV1/viewer';
import { edpApiV1 } from 'app/services/edpApiV1';
import { utils } from 'shared/helpers';
import { clientCookies } from 'shared/lib';
import { AccountMenuKeys, DropdownButtonProps, DropdownMenuProps } from './types';
import s from './index.module.scss';

const DropdownSkeleton = () => (
  <div className={s.button}>
    <Skeleton.Button active block />
  </div>
);

const DropdownButton: FC<DropdownButtonProps> = ({ overlay, email }) => (
  <Dropdown overlay={overlay} trigger={['click']}>
    <Button className={s.button}>
      <Space>
        {email} <DownOutlined />
      </Space>
    </Button>
  </Dropdown>
);

const DropdownMenu: FC<DropdownMenuProps> = ({ logout }) => {
  const { Item } = Menu;
  return (
    <Menu>
      {/*<Item key={AccountMenuKeys.settings}>*/}
      {/*  <Link to={Paths.home}>*/}
      {/*    <Space>*/}
      {/*      <SettingOutlined /> Настройки*/}
      {/*    </Space>*/}
      {/*  </Link>*/}
      {/*</Item>*/}
      <Item key={AccountMenuKeys.logout} onClick={logout}>
        <Space>
          <LogoutOutlined /> Выйти
        </Space>
      </Item>
    </Menu>
  );
};

export const AccountDropdown = () => {
  const email = useAppSelector(viewerModel.me.selectors.getEmail);
  const [logoutMutation] = useLogoutMutation();
  const { isLoading } = useMeQuery(null);
  const dispatch = useAppDispatch();

  const logout = async () => {
    try {
      await logoutMutation().unwrap();
      clientCookies.removeCredentials();
      dispatch(edpApiV1.util.resetApiState());
    } catch (e) {
      const responseErr = utils.getErrorData(e);
      if (responseErr) notification.error({ message: responseErr.message });
    }
  };

  return isLoading ? <DropdownSkeleton /> : <DropdownButton overlay={<DropdownMenu logout={logout} />} email={email} />;
};
